import React, { Component } from "react";
import { Grid, Cell, ListItem, ListItemContent, List } from "react-mdl";
import logo2 from "../Components/logo2.jpg";
import Animation from "../Components/animation";

class Contact extends Component {
  render() {
    return (
      <div className="contact-body">
        <Animation />
        <Grid className="contact-grid">
          <Cell col={6}>
            <h2>Hicham Fatih</h2>
            <img
              src={logo2}
              alt="logo2"
              style={{ height: "250px", width: "300px" }}
            />
            <p style={{ width: "75%", margin: "auto", paddingTop: "1em" }}>
              {" "}
              Que vous soyez une entreprise, une agence web ou un particulier,
              je serai content de répondre à vos besoins.
            </p>
          </Cell>
          <Cell col={6}>
            <h2>Conatct Me</h2>
            <hr />
            <div className="contact-list">
              <List>
                <ListItem>
                  <ListItemContent
                    style={{ fontSize: "20px", fontFamily: "Anton" }}
                  >
                    <i className="fa fa-phone-square" aria-hidden="true" />
                    (+212) 42-489-687
                  </ListItemContent>
                </ListItem>

                <ListItem>
                  <ListItemContent
                    style={{ fontSize: "18px", fontFamily: "Anton" }}
                  >
                    <i class="fa fa-envelope-square" aria-hidden="true"></i>
                    Fatihhicham0@gmail.com
                  </ListItemContent>
                </ListItem>
                <ListItem>
                  <ListItemContent
                    style={{ fontSize: "19px", fontFamily: "Anton" }}
                  >
                    <i className="fa fa-skype" aria-hidden="true" />
                    Fatih Hicham
                  </ListItemContent>
                </ListItem>
              </List>
            </div>
          </Cell>
        </Grid>
      </div>
    );
  }
}
export default Contact;
